import { Card, Classes, Radio, Spinner, SpinnerSize } from '@blueprintjs/core';
import { ace_hooks } from '@axo/shared/data-access/hooks';
import { FilterSet } from '../FilterSet';

interface Props {
  marketCountry: string;
  selectedBucket: string | undefined;
  setSelectedBucket: (id: string | undefined) => void;
}

export function BucketSelectionPanel({
  marketCountry,
  selectedBucket,
  setSelectedBucket,
}: Props) {
  const buckets = ace_hooks.useBuckets(marketCountry);

  if (buckets.isLoading) {
    return <Spinner size={SpinnerSize.SMALL} />;
  }

  if (!buckets.data || buckets.data.length < 1) {
    return (
      <p className={Classes.TEXT_MUTED}>
        <em>No buckets available</em>
      </p>
    );
  }

  return (
    <FilterSet>
      {buckets.data.map((bucket) => (
        <Card
          style={{ width: '238px', textAlign: 'left' }}
          key={bucket.ID}
          data-highlighted={bucket.ID === selectedBucket}
          elevation={bucket.ID === selectedBucket ? 2 : 1}
        >
          <Radio
            name="selectedBucket"
            checked={bucket.ID === selectedBucket}
            onChange={() => setSelectedBucket(bucket.ID)}
            label={bucket.Name}
            style={{ marginBottom: 0 }}
          />
        </Card>
      ))}
    </FilterSet>
  );
}
